<template lang="pug">
#resultado-pesquisa
    .resultado-header
        h3 Resultados

        i.close.mdi.mdi-close(@click='unfilter()')

    .resultado-body
        .agrupamento(
            v-if='!isEmpty(resultado)',
            v-for='cliente in resultado',
            :key='cliente.id'
        )
            agrupamento-resultado-pesquisa(:cliente='cliente')

        .sem-resultado(v-if='isEmpty(resultado)')
            empty-result(message='Nenhuma área encontrada')
</template>

<script>
import Store from '../store';
import AgrupamentoResultadoPesquisa from './AgrupamentoResultadoPesquisa';
import EmptyResult from './EmptyResult';

export default {
    name: 'ResultadoPesquisa',

    components: { EmptyResult, AgrupamentoResultadoPesquisa },

    props: {
        resultado: {
            type: Array,
            required: true
        }
    },

    methods: {
        unfilter() {
            Store.dispatch('limparFiltro');
        },

        isEmpty(list) {
            return list.length === 0;
        }
    }
};
</script>

<style scoped lang="scss">
#resultado-pesquisa {
    width: 28%;
    background-color: var(--white);
    overflow: hidden;
    margin-left: 70px;
    min-width: 340px;
    height: 100vh;
    @include box-shadow(3px, 0, 6px, rgba(0, 0, 0, 0.04));

    .resultado-header {
        display: flex;
        position: fixed;
        justify-content: space-between;
        border-bottom: solid 1px var(--default-border-color);
        z-index: 1030;
        height: 70px;
        align-items: center;
        min-width: 340px;
        padding: 0 20px;
        background-color: var(--white);
        width: 21%;
        @include box-shadow(3px, 0, 6px, rgba(0, 0, 0, 0.04));

        h3 {
            font-weight: map-get($font-weight, medium);
        }
    }

    .close {
        cursor: pointer;
    }

    .resultado-body {
        height: 100%;
        padding: 80px 20px 20px 20px;
        width: 100%;
        overflow: auto;

        @include scroll-bar();
    }
}
</style>
